export enum SectionType {
  General,
  Number,
  Fraction,
  Exponential,
  Date,
  Duration,
  Text,
}
